define('OutSystems/ClientRuntime/LightImmutable',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ImmutableList = exports.defineRecordClass = void 0;
    function copyArray(arr) {
        var len = arr.length;
        var clone = new Array(len);
        while (len-- > 0) {
            clone[len] = arr[len];
        }
        return clone;
    }
    var recordGenNumber = 0;
    function defineRecordClass(defaults) {
        var keys = Object.keys(defaults);
        var ctor = "function ImmutableRecord" + recordGenNumber + "(o) { this._ = o || defaults }\n" +
            ("function R" + recordGenNumber + "(o) {\n");
        keys.forEach(function (key) { return (ctor += "this." + key + " = o." + key + ";\n"); });
        ctor += "}\n";
        var getBody = "switch(key){\n";
        keys.forEach(function (key) {
            getBody += "case \"" + key + "\": return this._." + key + ";\n";
        });
        getBody += "}";
        var setBody = "var clone = new R" + recordGenNumber + "(this._);\n";
        setBody += "switch (key) {\n";
        keys.forEach(function (key) {
            setBody += "case \"" + key + "\": clone." + key + "=value;break;";
        });
        setBody += "}\n";
        setBody += "return new ImmutableRecord" + recordGenNumber + "(clone);\n";
        var toJSBody = "return {\n";
        toJSBody += keys.map(function (key) { return key + ": this._." + key; }).join(",\n");
        toJSBody += "\n};";
        var complete = ctor +
            ("ImmutableRecord" + recordGenNumber + ".prototype.get = function(key){" + getBody + "};\n") +
            ("ImmutableRecord" + recordGenNumber + ".prototype.set = function(key,value){" + setBody + "};\n") +
            ("ImmutableRecord" + recordGenNumber + ".prototype.toJS = function(){" + toJSBody + "};\n") +
            ("return ImmutableRecord" + recordGenNumber + ";");
        recordGenNumber++;
        return new Function("defaults", complete)(defaults);
    }
    exports.defineRecordClass = defineRecordClass;
    var MAX_SEGMENT_SIZE = 128;
    var ImmutableList = (function () {
        function ImmutableList(values, lengths) {
            if (typeof lengths !== "undefined") {
                this._values = values;
                this._lengths = lengths;
            }
            else if (typeof values !== "undefined") {
                var self_1 = ImmutableList.fromJS(values);
                this._values = self_1._values;
                this._lengths = self_1._lengths;
            }
            else {
                this._values = [];
                this._lengths = [];
            }
        }
        ImmutableList.prototype.clear = function () {
            return new ImmutableList();
        };
        ImmutableList.prototype.clone = function () {
            return this;
        };
        ImmutableList.prototype.count = function () {
            var total = 0, len = this._lengths.length;
            while (len-- > 0) {
                total += this._lengths[len];
            }
            return total;
        };
        ImmutableList.prototype.isEmpty = function () {
            return this._lengths.length === 0;
        };
        ImmutableList.prototype.get = function (index) {
            var i = 0, p = index;
            var len = this._lengths.length;
            while (i < len && index >= 0) {
                if (p < this._lengths[i]) {
                    return this._values[i][p];
                }
                p -= this._lengths[i];
                i++;
            }
        };
        ImmutableList.prototype.set = function (index, value) {
            var segment = 0, p = index;
            var values = copyArray(this._values);
            var lengths = this._lengths;
            var len = lengths.length;
            while (segment < len && index >= 0) {
                if (p < this._lengths[segment]) {
                    values[segment] = copyArray(values[segment]);
                    values[segment][p] = value;
                    return new ImmutableList(values, lengths);
                }
                p -= lengths[segment];
                segment++;
            }
        };
        ImmutableList.prototype.push = function (value) {
            var pos = this._values.length - 1;
            var values;
            var lengths;
            if (pos < 0) {
                pos = 0;
                values = [[]];
                lengths = [0];
            }
            else {
                values = copyArray(this._values);
                lengths = copyArray(this._lengths);
            }
            var lastSegment = values[pos];
            if (lastSegment.length < MAX_SEGMENT_SIZE) {
                var lastSegmentLen = lastSegment.length;
                var lastSegmentClone = new Array(lastSegmentLen + 1);
                var i = lastSegmentLen;
                while (i-- > 0) {
                    lastSegmentClone[i] = lastSegment[i];
                }
                lastSegmentClone[lastSegmentLen] = value;
                values[pos] = lastSegmentClone;
                lengths[pos]++;
            }
            else {
                var newLastSegment = [value];
                values.push(newLastSegment);
                lengths.push(1);
            }
            return new ImmutableList(values, lengths);
        };
        ImmutableList.prototype.insert = function (index, value) {
            var segment = 0, p = index;
            var values = copyArray(this._values);
            var lengths = copyArray(this._lengths);
            var len = lengths.length;
            while (segment < len && p >= 0) {
                if (p < lengths[segment]) {
                    if (lengths[segment] === MAX_SEGMENT_SIZE) {
                        var b1size = (MAX_SEGMENT_SIZE / 2) | 0;
                        var b2size = MAX_SEGMENT_SIZE - b1size;
                        lengths.splice(segment, 1, b1size, b2size);
                        var b1values = new Array(b1size);
                        var b2values = new Array(b2size);
                        for (var b1p = 0; b1p < b1size; b1p++) {
                            b1values[b1p] = values[segment][b1p];
                        }
                        for (var b2p = 0, vp = b1size; b2p < b2size;) {
                            b2values[b2p++] = values[segment][vp++];
                        }
                        values.splice(segment, 1, b1values, b2values);
                        len++;
                        continue;
                    }
                    var i = 0;
                    var segmentLen = lengths[segment];
                    var newValues = new Array(segmentLen + 1);
                    var oldValues = values[segment];
                    for (; i < p; i++) {
                        newValues[i] = oldValues[i];
                    }
                    newValues[p] = value;
                    var j = i + 1;
                    while (i < segmentLen) {
                        newValues[j++] = oldValues[i++];
                    }
                    lengths[segment]++;
                    values[segment] = newValues;
                    return new ImmutableList(values, lengths);
                }
                p -= lengths[segment];
                segment++;
            }
            lengths.push(1);
            values.push([value]);
            return new ImmutableList(values, lengths);
        };
        ImmutableList.prototype.remove = function (index) {
            var segment = 0;
            var p = index;
            var lengths = copyArray(this._lengths);
            var values = copyArray(this._values);
            var len = lengths.length;
            while (segment < len && p >= 0) {
                if (p < lengths[segment]) {
                    var segmentLen = --lengths[segment];
                    var segmentValues = new Array(segmentLen);
                    var i = 0, j = 0;
                    while (i < segmentLen) {
                        if (i === p) {
                            j++;
                        }
                        segmentValues[i++] = values[segment][j++];
                    }
                    values[segment] = segmentValues;
                    if (lengths[segment] === 0) {
                        lengths.splice(segment, 1);
                        values.splice(segment, 1);
                    }
                    return new ImmutableList(values, lengths);
                }
                p -= lengths[segment];
                segment++;
            }
        };
        ImmutableList.prototype.reduce = function (callback, init) {
            for (var i = 0; i < this._values.length; i++) {
                var segment = this._values[i];
                for (var j = 0; j < segment.length; j++) {
                    init = callback(init, segment[j]);
                }
            }
            return init;
        };
        ImmutableList.prototype.map = function (callback) {
            var result = new Array(this.count());
            var p = 0;
            for (var i = 0; i < this._values.length; i++) {
                var segment = this._values[i];
                for (var j = 0; j < segment.length; j++) {
                    result[p] = callback(segment[j], p);
                    p++;
                }
            }
            return result;
        };
        ImmutableList.prototype.pushAll = function (values) {
            if (values.length === 0) {
                return this;
            }
            var newList = new ImmutableList(values);
            var newValues = this._values.concat(newList._values);
            var newLengths = this._lengths.concat(newList._lengths);
            return new ImmutableList(newValues, newLengths);
        };
        ImmutableList.prototype.forEach = function (callbackfn) {
            for (var i = 0; i < this._values.length; i++) {
                var segment = this._values[i];
                for (var j = 0; j < segment.length; j++) {
                    callbackfn(segment[j]);
                }
            }
            return undefined;
        };
        ImmutableList.prototype.addFromOther = function (other) {
            if (other.count() === 0) {
                return this;
            }
            if (this._values.length === 0) {
                return other;
            }
            var lengths = new Array(this._lengths.length + other._lengths.length);
            var values = new Array(this._values.length + other._values.length);
            var thisSegment = 0;
            var otherSegment = 0;
            while (thisSegment < this._values.length) {
                values[thisSegment] = this._values[thisSegment];
                lengths[thisSegment] = this._lengths[thisSegment];
                thisSegment++;
            }
            while (otherSegment < other._values.length) {
                values[thisSegment] = other._values[otherSegment];
                lengths[thisSegment] = other._lengths[otherSegment];
                thisSegment++;
                otherSegment++;
            }
            return new ImmutableList(values, lengths);
        };
        ImmutableList.fromJS = function (arr) {
            var segments = Math.ceil(arr.length / MAX_SEGMENT_SIZE) | 0;
            var values = new Array(segments);
            var lengths = new Array(segments);
            var done = 0, missing = 0;
            for (var i = 0; i < segments; i++) {
                missing = arr.length - done;
                var thismax = missing > MAX_SEGMENT_SIZE ? MAX_SEGMENT_SIZE : missing;
                lengths[i] = thismax;
                values[i] = new Array(thismax);
                for (var j = 0; j < thismax; j++) {
                    values[i][j] = arr[done + j];
                }
                done += thismax;
            }
            return new ImmutableList(values, lengths);
        };
        return ImmutableList;
    }());
    exports.ImmutableList = ImmutableList;
});
//# sourceMappingURL=LightImmutable.js.map;
